// Feature flag name constants to prevent typos
export const FEATURE_FLAGS = {
  // Payment Features
  DELTA_PAY: 'delta-pay',

  REFERRAL_PROGRAMME: 'referral-programme',
} as const;

export type FeatureFlagName = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];
